var _jsxFileName = "/codebuild/output/src1493404089/src/bitbucket.org/newyuinc/adc-polaris-web/src/components/utility/PasswordRequirements/index.tsx";
import React, { memo } from 'react';
import { HStack, Stack, Text } from '@adc/parallax-component-library';
import { IconValidationInvalid, IconValidationNotValidated, IconValidationValid } from '@adc/parallax-icons';
import i18n from 'Utilities/i18n';
const PasswordRequirements = /*#__PURE__*/memo(({
  requirements
}) => {
  return /*#__PURE__*/React.createElement(Stack, {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 18,
      columnNumber: 5
    }
  }, requirements.map(requirement => {
    return /*#__PURE__*/React.createElement(HStack, {
      alignItems: "center",
      key: requirement.data.key,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 21,
        columnNumber: 11
      }
    }, requirement.isInvalid ? /*#__PURE__*/React.createElement(IconValidationInvalid, {
      color: "$support.danger.surfaceOnColorAlt",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 23,
        columnNumber: 15
      }
    }) : requirement.match ? /*#__PURE__*/React.createElement(IconValidationValid, {
      color: "$support.positive.default",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 25,
        columnNumber: 15
      }
    }) : /*#__PURE__*/React.createElement(IconValidationNotValidated, {
      color: "$neutral.40",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 27,
        columnNumber: 15
      }
    }), /*#__PURE__*/React.createElement(Text, {
      marginLeft: "$2",
      testID: `Login.content.signInForm.formField.password.helpText.${requirement.data.key}`,
      nativeID: `Login.content.signInForm.formField.password.helpText.${requirement.data.key}`,
      color: requirement.isInvalid ? '$support.danger.surfaceOnColorAlt' : '$neutral.60',
      type: "$bodySmall.default",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 29,
        columnNumber: 13
      }
    }, i18n.t(`Login.content.signInForm.formField.password.helpText.${requirement.data.key}`, {
      count: requirement.data.value
    })));
  }));
});
PasswordRequirements.displayName = 'PasswordRequirements';
export { PasswordRequirements };